/**
 * SVG 元素使用的标准 XML 命名空间。
 */
export const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * SVG 1.1 `xlink:*` 属性使用的 XML 命名空间。
 */
export const XLINK_NS = 'http://www.w3.org/1999/xlink';
